import React from 'react';

export const UserViewContext = React.createContext();